luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  button.canPlaceBet = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    return !gameController.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake = button.stakeController.BaseStake / 100;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    this.button.buttonDisabled.alpha = allow ? 1 : 0.5;

    button.idleAnim.visible =
      this._flags.canSpin &&
      !autoplayManager.isAutoplayEnabled() &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      !button._flags.showLuckyBetActive &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    button.luckyBetMessage.visible = this._flags.canSpin && !this._flags.modal.active;

    if (this._flags.modal.active || !this._flags.canSpin) {
      button.luckyBetMessage.alpha = 0;

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    }

    if (button.luckyBetAnim) {
      button.luckyBetAnim.visible = allow ? 1 : 0;
    }

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe("spinner:GameConfigEvent", button.onConfig.bind(button));
    messageBus.subscribe("common:PromotionStarted", button.promotionStarted.bind(button));
    messageBus.subscribe("common:PromotionEnded", button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.stakeController = resourceManager.getController("stakeController");
    button.luckyBetMessage = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage");
    button.animParent = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton:button");

    button.luckyBetMessage.interactive = true;
    button.luckyBetMessage.mousedown = button.luckyBetMessage.touchstart = () => {
      button.luckyBetMessage.alpha = 0;

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    };

    // create here on top of button
    button.luckyBetAnim = resourceManager.createObject("movie", "luckyBetAnim", button.animParent, {
      definition: "LuckyBet",
      x: -83,
      y: -75,
      loop: false,
      scale: 1,
    });
    button.luckyBetAnim.gotoAndStop(0);
    button.luckyBetAnim.visible = true;

    button.idleAnim = resourceManager.createObject("movie", "luckyBetIdle", button.animParent, {
      definition: "luckyBetIdle",
      anchor: 0.5,
    });
    button.idleAnim.loop = false;
    button.idleAnim.gotoAndStop(0);

    timerManager.addTimeout(3000, () => {
      button.playIdleAnim();
    });

    button.luckyBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;
  };

  button.playIdleAnim = function () {
    button.idleAnim.gotoAndPlay(0);

    timerManager.addTimeout(3000, () => {
      button.playIdleAnim();
    });
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.idleAnim.visible = true;

      button.luckyBetAnim.gotoAndStop(0);

      gameData.encoreEnabled = false;

      button.handleStakeChange(true);
    }
  };

  button.handleStakeChange = function (broadcast) {
    gameController.luckyBetToggled = true;
    gameData.recoveryStake = undefined;

    let luckyBetEnabled = gameData.encoreEnabled;
    button.stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(button.stakeController.BaseStake * (luckyBetEnabled ? 1.5 : 1));

    if (broadcast) {
      button.stakeController.broadcastCurrentStake();
    }
  };

  button.setRecovery = function () {
    button._flags.showLuckyBetActive = true;
    button.luckyBetAnim.visible = true;
    button.luckyBetAnim.gotoAndPlay(4);
    gameData.encoreEnabled = true;
    button.stakeController.setStakeMultiplier(1.5);
    this.button.buttonDisabled.visible = false;
    this.button.buttonEnabled.visible = true;
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;

    if (button._flags.showLuckyBetActive) {
      if (button.luckyBetMessage !== undefined) {
        button.luckyBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(4000, undefined, function () {
          button.innerFadeTimer = timerManager.addTimer(
            500,
            function (progress) {
              button.luckyBetMessage.alpha = 1 - progress;
            },
            function () {
              button.luckyBetMessage.alpha = 0.0;
            }
          );
        });

        button.luckyBetAnim.gotoAndPlay(0);

        button.idleAnim.visible = false;

        soundManager.play("activateGoldenBet");

        gameData.encoreEnabled = true;
        button.handleStakeChange(true);
      }
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play("cancelGoldenBet");
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "luckyBetToggleButton",
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
